import "./ErrorPage.scss";
import { useTranslation } from "react-i18next";
import GtSystemAdministrationMessages from "src/components/Common/GTSystemAdministrationMessages";
import GtSpinner from "src/components/Common/GtSpinner";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

function ErrorPage() {
  const error = useRouteError();

  let message = "";
  let status = 500;

  if (isRouteErrorResponse(error)) {
    status = error.status;
    message = error.data?.message || error.statusText;
  } else if (error instanceof Error) {
    message = error.message;
  } else if (typeof error === "string") {
    message = error;
  }

  const { t } = useTranslation();
  return (
    <article className="gt-errorPage">
      <section className="gt-errorPage__logo">
        <GtSpinner />
        <span className="gt-errorPage__logo-text">GrantThornton</span>
      </section>
      <section className="gt-errorPage__administrationMessages">
        <GtSystemAdministrationMessages />
      </section>
      <section className="gt-errorPage__title">
        <h3
          dangerouslySetInnerHTML={{
            __html: message
              ? t("General.AnErrorHasOccuredCrmApi")
              : t("General.AnErrorHasOccured"),
          }}
        />
      </section>
    </article>
  );
}

export default ErrorPage;
